// CSS can't see text nodes, so <p>A <strong>Title</strong> (1981).</p> would pass as a bold question.
(function () {
    function isWhollyBold(p) {
        const walker = document.createTreeWalker(p, window.NodeFilter.SHOW_TEXT);
        let hasText = false;
        let node;
        while ((node = walker.nextNode())) {
            if (!node.textContent.trim()) continue;
            if (!node.parentElement.closest('strong, b')) return false;
            hasText = true;
        }
        return hasText;
    }

    function isClosingNote(p) {
        if (p.children.length !== 1 || p.children[0].tagName !== 'EM') return false;
        const text = p.textContent.trim();
        return !!text && text === p.children[0].textContent.trim();
    }

    function tagInterview() {
        const root = document.querySelector('.tag-interview .gh-content');
        if (!root) return;
        const ps = root.querySelectorAll(':scope > p');
        ps.forEach((p) => {
            if (isWhollyBold(p)) p.classList.add('is-question');
        });
        // Last paragraph only, so a lone italic answer mid-conversation isn't caught.
        const last = ps[ps.length - 1];
        if (last && isClosingNote(last)) last.classList.add('is-closing-note');
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', tagInterview);
    } else {
        tagInterview();
    }
})();
